import { api } from '@/app'
import { Question, QuestionSample } from '@/types'
import { queryClient } from './queryClient'
import { useQuery } from '@tanstack/react-query'

export type AnswerInfo = {
  question: Question['id']
  value: number
  skip?: boolean
  comment?: string
}

export type AnswerData = Pick<AnswerInfo, 'comment' | 'value' | 'skip'>

export async function fetchPulseQuestions(
  questionsIds: Question['id'][] | null = null,
  params = {}
): Promise<QuestionSample> {
  const response = await api.get<QuestionSample>('questions/pulse/', {
    params: {
      questions: questionsIds?.length ? questionsIds : undefined,
      ...params
    }
  })

  return response.data
}

export async function answerManyQuestions(data: AnswerInfo[]) {
  const response = await api.post('questions/answers/answer_many/', data)
  return response.data
}

export async function answerQuestion(data: AnswerInfo) {
  const response = await api.post('questions/answers/', data)
  return response.data
}

const queryKey = ['pulse-questions']
export const pulseQueryKey = queryClient.queryKey(queryKey)

export const prefetchPulseQuestions = (ids: Question['id'][] = null) => {
  return queryClient.client.prefetchQuery({
    queryKey: [...queryKey, ids],
    queryFn: () => fetchPulseQuestions(ids)
  })
}

export const usePulseQuestionsQuery = (ids: Question['id'][], enabled: boolean) => {
  return useQuery({
    queryFn: () => fetchPulseQuestions(ids),
    queryKey,
    enabled
  })
}
